import { Loader } from './Loader';
import * as log from 'loglevel';

/**
 * Loads urls using ajax
 * @extends Loader
 * @category loader
 * @author Geoffrey Mayeux
 */
class AjaxLoader extends Loader{
	/**
	 * Create a DomLoader
 	 * @param {Object} options An Option object. Look the documentation of the {@link https://developer.mozilla.org/fr/docs/Web/API/Fetch_API/Using_Fetch|fetch} method 
	 */
	constructor({
			method 		= 'GET',
			params 		= {},
			headers 	= {},
			body 		= null,
			cache 		= 'no-cache',
			redirect 	= 'follow',
			callback 	= async () => {}
		} = {}){
		super();

		this.options = {
			method:method,
			params:params,
			headers:headers,
			body:body,
			cache:cache,
			redirect:redirect
		};

		this.callback = callback;
	}

	accepts(item){
		return typeof item == "string";
	}

	async loadItem(item){
		log.debug('loadItem', item);

		return window.fetch(item, this.options)
		.then(async response => {
			await this.callback(response);
			this._value = await response.text();
			return this._value;
		});
	}

}

export default AjaxLoader;
export { AjaxLoader };